import { render, staticRenderFns } from "./cashRegisterSkeleton.vue?vue&type=template&id=4b4ab94e&scoped=true&"
import script from "./cashRegisterSkeleton.vue?vue&type=script&lang=js&"
export * from "./cashRegisterSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4ab94e",
  null
  
)

export default component.exports